import { Avatar, Badge, Menu, Select, Text } from "@mantine/core";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { mapRoleToLabel } from "./utilities";
import { IconDoorExit, IconExchange } from "@tabler/icons-react";
import { deleteCookie, setCookiesSession } from "../cookiesSession";
import { changeUserRole } from "../apis/userApis";
import { Loader } from "@mantine/core";

const AppHeader = () => {
  const navigate = useNavigate();
  const getCookiesSession = (cookieName) => Cookies.get(cookieName);

  const cookie = getCookiesSession("LawSignaUserDataMaster");

  let userData = {
    name: "",
    email: "",
    picture: "",
    loginAs: {},
    userRole: [],
  };

  try {
    if (cookie) {
      const cookieData = JSON.parse(cookie);
      userData = cookieData?.user || userData;
    }
  } catch (err) {
    console.error("Invalid user cookie", err);
  }
  const [opened, setOpened] = useState(true);

  const logoutHandler = () => {
    if (getCookiesSession("LawSignaUserDataMaster")) {
      deleteCookie("LawSignaUserDataMaster");
      deleteCookie("masterResult");
    }
    window.location.reload();
  };
  console.log("userData: ", userData);

  if (!userData || !userData.loginAs || !Array.isArray(userData.userRole)) {
    return (
      <div className="flex justify-center items-center h-16">
        <Loader size="sm" />
      </div>
    );
  }

  return (
    <div className="flex flex-row justify-between mx-8">
      {/* <img
        style={{ width: "8rem" }}
        src="https://mswordapp.lawsigna.com/assets/images/SecondaryLogo.png"
        alt="TrueCounsel"
      /> */}
      <div className="flex items-center gap-2">
        <img
          style={{ width: "8rem" }}
          src="https://lawsigna-public-bucket.s3.us-east-1.amazonaws.com/LawsignaLogo.png"
          alt="LawSigna"
        />

        <div
          style={{
            padding: "3px 10px",
            borderRadius: "999px",
            border: "1px solid #d1d5db",
            backgroundColor: "#edeeef",
            fontSize: "0.80rem",
            fontWeight: 600,
            fontFamily: "Cinzel",
          }}
        >
          Obligations Hub
        </div>
      </div>
      {/* <div className="flex items-center gap-3">
  <img
    style={{ width: "8rem" }}
    src="https://mswordapp.lawsigna.com/assets/images/SecondaryLogo.png"
    alt="TrueCounsel"
  />

  <Badge
    size="lg"
    radius="xl"
    variant="filled"
    color="blue"
    styles={{
      root: {
        fontSize: "0.85rem",
        padding: "6px 12px",
        fontWeight: 600,
      },
    }}
  >
    Obligation Hub
  </Badge>
</div> */}
      <div className="flex">
        {/* <Select
          required
          className="max-w-lg mr-2"
          placeholder="Select Role to login as"
          data={roles.map((role) => ({
            label: role.name,
            value: role.id,
            pass: role,
          }))}
          // label={currentUser.loginAs.name}
          value={currentUser.loginAs.id}
          onChange={(pass) => handleRoleChange(pass)}
        /> */}
        <Select
          className="flex items-center cursor-pointer mr-4"
          value={
            userData && userData.loginAs && userData.loginAs.id
              ? userData.loginAs.id
              : ""
          }
          data={(userData.userRole || []).map(({ name, id }) => ({
            label: name,
            value: id,
          }))}
          onChange={async (val) => {
            const resp = await changeUserRole({ roleId: val });
            if (resp?.success && resp?.result?.token && resp?.result?.user) {
              setCookiesSession(
                "LawSignaUserDataMaster",
                JSON.stringify(resp.result),
                2,
              );
              navigate("/dashboard");
            }

            window.location.reload();
          }}
          // data={userData.role.split(",")}
        />
        <Menu>
          <Menu.Target>
            <div
              onClick={() => {
                setOpened(!opened);
              }}
              className="flex items-center cursor-pointer"
            >
              {userData.picture?.length ? (
                <Avatar size="md" src={userData.picture} radius="xl" />
              ) : (
                <Avatar size="md" radius="xl">
                  {userData.name ? userData.name.charAt(0).toUpperCase() : "U"}
                </Avatar>
              )}
              <div className="ml-2 flex flex-col">
                <Text size="md">{userData.name || "-"}</Text>
                <Text size="xs">{userData.email || "-"}</Text>
              </div>
            </div>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item
              onClick={() =>
                window.open(process.env.REACT_APP_LANDING_URL, "_blank")
              }
              icon={<IconExchange size={14} />}
            >
              choose manager
            </Menu.Item>
            <Menu.Item
              onClick={logoutHandler}
              icon={<IconDoorExit size={14} />}
            >
              Logout
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </div>
    </div>
  );
};

export default AppHeader;
